import React from "react";
import { Button } from "react-md";
import successGif from "../../../../../../../assets/images/done-animation.gif";

const SuccessTotalPaymentWithWallet = ({
  onClose,
  withCreateAppointment,
  appointmentCreated,
  props,
}) => {
  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      {/* SUCCESS GIF */}
      <div style={{ marginTop: "25px" }}>
        <img src={successGif} alt="success" height="150px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px", marginTop: "10px" }}>
        {withCreateAppointment
          ? "Appointment created successfully!"
          : "Payment successful!"}
      </div>

      {/* BUTTON */}
      <div className="pld-center" style={{ marginTop: "25px" }}>
        <Button
          raised
          className="zy-btn-orange pld-main-btn"
          onClick={
            withCreateAppointment
              ? () => {
                  props.setView(2, {
                    appId: appointmentCreated?.id,
                  });
                }
              : onClose
          }
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default SuccessTotalPaymentWithWallet;
